"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _modalModule = _interopRequireDefault(require("./modal.module.css"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _themeModule = _interopRequireDefault(require("../../../styles/theme.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Modal = function Modal(props) {
  var id = props.id,
      children = props.children,
      fadeIn = props.fadeIn,
      darkenedBackground = props.darkenedBackground,
      noScroll = props.noScroll;

  if (!fadeIn) {
    return null;
  }

  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", {
    id: id ? id : null,
    className: (0, _classnames.default)(noScroll ? _modalModule.default["modal-open-no-scroll"] : _modalModule.default["modal-open"])
  }, _react.default.createElement("div", {
    id: id ? "".concat(id, "_wrapper") : null,
    className: (0, _classnames.default)(_themeModule.default.arag, _modalModule.default.modal, _modalModule.default.fade, _modalModule.default.in),
    tabIndex: -1,
    role: "dialog",
    style: {
      display: "block"
    }
  }, children)), darkenedBackground && fadeIn && _react.default.createElement("div", {
    id: id ? "".concat(id, "_backdrop") : null,
    className: (0, _classnames.default)(_modalModule.default["modal-backdrop"], _modalModule.default.fade, _modalModule.default.in)
  }));
};

Modal.propTypes = {
  /** String text that specifies a unique id for an HTML element. Consistent Id type: snake_case*/
  id: _propTypes.default.string,

  /** Boolean prop that when it is true it will display the modal */
  fadeIn: _propTypes.default.bool,
  children: _propTypes.default.any,

  /** Boolean prop that when it is true it will display dark background to the modal */
  darkenedBackground: _propTypes.default.bool,

  /** Boolean prop that when it is true it will hide scroll parent of parent, but still scroll */
  noScroll: _propTypes.default.bool
};
var _default = Modal;
exports.default = _default;